import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import InlineSpinner from 'components/InlineSpinner'
import messages from 'lang'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

import { Header, ModalTitle } from '../../styles'

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h1`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 150%;
  color: ${color('white')};
`

const Text = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
`

const Logo = styled.img`
  height: 2rem;
`

const Qr = styled.img`
  width: 200px;
  height: 200px;
  padding: 1rem;
  border: 2px solid ${color('blue600')};
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 2.5rem;
`

const Button = styled(CeruleanButton)`
  margin-top: 1.5rem;
`

const Separator = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;

  ::before,
  ::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${color('medium')};
  }

  :not(:empty)::before {
    margin-right: 0.25em;
  }

  :not(:empty)::after {
    margin-left: 0.25em;
  }
`

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 0;

  span {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${color('body')};
    padding-left: 0.5rem;
  }
`

const Main = styled.main`
  color: ${color('white')};
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const LOADING_DELAY = 10 * 1000

type Props = {
  institutionImg: string
  linkUrl: string
  onBack: () => void
  onBrowserContinueClick?: () => void
  qrImg: string
  title: string
}
const ConnectBank = ({
  institutionImg,
  linkUrl,
  onBack,
  onBrowserContinueClick,
  qrImg,
  title
}: Props) => {
  const [waiting, setWaiting] = useState<boolean>(false)
  useEffect(() => {
    setTimeout(() => setWaiting(true), LOADING_DELAY)
  }, [])

  return (
    <>
      <Header>
        <Arrow onClick={onBack} side={ArrowSide.LEFT} />
        <ModalTitle>
          <I18n data={messages[title]} />
        </ModalTitle>
      </Header>
      <Main>
        <Section>
          <Logo src={institutionImg} />
          <Title>
            <I18n data={messages.link_bank_connect_bank_qr_title} />
          </Title>
          <Text>
            <I18n data={messages.link_bank_connect_bank_qr_subtitle} />
          </Text>

          <Qr src={qrImg} />
        </Section>
        <Separator>
          <I18n data={messages.or} />
        </Separator>
        <Section>
          <Title>
            <I18n data={messages.link_bank_connect_bank_desktop} />
          </Title>
          <Button
            onClick={() => {
              if (onBrowserContinueClick) onBrowserContinueClick()
              window.open(linkUrl, '_blank')
            }}
          >
            <I18n data={messages.button_continue_in_browser} />
          </Button>
        </Section>
      </Main>
      {waiting && (
        <Loading>
          <InlineSpinner />
          <span>
            <I18n data={messages.link_bank_connect_bank_loading} />
          </span>
        </Loading>
      )}
    </>
  )
}

export default ConnectBank
